import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import slide1 from '../../assets/slides/slide-1.jpeg';
import slide2 from '../../assets/slides/slide-2.jpeg';
import slide3 from '../../assets/slides/slide-3.jpeg';
import slide4 from '../../assets/slides/slide-4.jpeg';
import slide5 from '../../assets/slides/slide-5.jpeg';
import slide6 from '../../assets/slides/slide-6.jpeg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Quality Inverters & Solar Solutions",
      description: "Botswana's trusted source for reliable power solutions",
      buttonText: "Shop Now",
      buttonLink: "/products?category",
      image: slide1,
      theme: "primary"
    },
    {
      id: 2,
      title: "Black Friday Specials",
      description: "No gimmicks just the best prices on all solar equipment",
      buttonText: "Our Services",
      buttonLink: "/specialist",
      image: slide2,
      theme: "dark"
    },
    {
      id: 3,
      title: "Complete Solar Systems",
      description: "Everything you need for your home or business solar setup",
      buttonText: "Explore Products",
      buttonLink: "/products/category",
      image: slide3,
      theme: "accent"
    },
    {
      id: 4,
      title: "Expert Installation Support",
      description: "Professional installation services across Botswana",
      buttonText: "Get Quote",
      buttonLink: "/contact",
      image: slide4,
      theme: "secondary"
    },
    {
      id: 5,
      title: "Premium Solar Equipment",
      description: "Top brands: Jinko, Deye, Victron, and more",
      buttonText: "View Brands",
      buttonLink: "/products?brand",
      image: slide5,
      theme: "primary"
    },
    {
      id: 6,
      title: "Power Your Future",
      description: "Switch to solar and save on energy costs",
      buttonText: "Learn More",
      buttonLink: "/about",
      image: slide6,
      theme: "dark"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero-slideshow">
      <div className="slides-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''} ${slide.theme}`}
          >
            <div className="slide-content">
              <div className="text-content">
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
                <div className="hero-buttons">
                  <Link to={slide.buttonLink} className="btn btn-primary">
                    {slide.buttonText}
                  </Link>
                  <Link to="/about" className="btn btn-secondary">
                    Learn More
                  </Link>
                </div>
              </div>
              <div className="image-content">
                <div className="slide-image">
                  {/* Replace placeholder with actual image */}
                  <img 
                    src={slide.image} 
                    alt={slide.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button className="slide-nav prev" onClick={prevSlide}>
        ‹
      </button>
      <button className="slide-nav next" onClick={nextSlide}>
        ›
      </button>

      {/* Slide Indicators */}
      <div className="slide-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;